import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { FullCalendarModule } from '@fullcalendar/angular';
import * as $ from 'jquery';
import { MyservicesService } from './myservices.service';
// import { UploadassignmentsModule } from './layout/uploadassignments/uploadassignments.module';
// import { UploadassignmentsComponent } from './layout/uploadassignments/uploadassignments.component';
import { MaterialModule } from './material/material.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatStepperModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LanguageTranslationModule,
        AppRoutingModule,
        HttpModule,
        FullCalendarModule,
        MaterialModule
    ],
    declarations: [AppComponent],
    providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}, AuthGuard, MyservicesService],
    bootstrap: [AppComponent]
})
export class AppModule {}
